import _ from "lodash";
import {CONGRATS_STEP_ID} from "../../constants";

export const initServiceNavigateBack = async (currService, lastFinishedStep) => {
  currService.finished = false;
  if(lastFinishedStep){
    await currService.goToStep(lastFinishedStep);
  } else if(currService.step && currService.step.uid === CONGRATS_STEP_ID){
    // as there is no back button in congrats step
    await currService.prevStep();
  }
  // store current step
  await currService.sendCurrentStep(_.get(currService.step, 'uid'));
}

export const invalidateStaleMenus = (menuItems, data, currMenu) => {
  if(data && data.onboarding_answers){
    menuItems.forEach((item, idx) => {
      if(idx >= currMenu){
        item.invalidateStaleSteps(data.onboarding_answers)
      }
    });
  }
}

function getHighestIndexInMenuItems(menuItems, idsWithAnswers) {
  const idsSet = new Set(idsWithAnswers);

  // Loop backwards through menuItems to find the highest index match immediately
  for (let i = menuItems.length - 1; i >= 0; i--) {
    if (idsSet.has(menuItems[i].uid)) {
      return i;
    }
  }

  return -1; // No common item found - should never happen
}

function getMenuIdxToInit(currentStep, menuItems, onboardingAnswers){
  const latestMenuIdx = getHighestIndexInMenuItems(
    menuItems, Object.keys(onboardingAnswers), currentStep
  )
  // we need to init all steps incl last.
  return latestMenuIdx < currentStep ? currentStep : latestMenuIdx + 1;
}

export const initStepsAfterCurrent = async (isNewDesign, setLoading, currentStep, menuItems, setServiceInitialData, data) => {
  if(isNewDesign) {
    setLoading(true);
    const idxToInit = getMenuIdxToInit(currentStep, menuItems, data.onboarding_answers)
    let prevService = menuItems[currentStep];
    // init all steps after current
    for (let i = currentStep + 1; i < idxToInit; i++) {
      const service = menuItems[i];
      setServiceInitialData(service, prevService, data);
      await service.__setQuestionnaire(data.onboarding_answers, true);
      prevService = service;
    }
    setLoading(false);
  }
}